import { APIJobsPerStatusModel } from "../Models/API/APIJobsPerStatusModel"
import { hasValue } from "../Models/Client/FetchState"
import { useAppInstance } from "./useAppInstance"
import { useJobCount } from "./useJobCount"

export const useJobTotalCount = (appID: string, isMessagesPath = false) => {
    const instanceFetch = useAppInstance(appID)
    const jobCounts = useJobCount(appID)

    return hasValue(instanceFetch)
        ? isMessagesPath
            ? instanceFetch.value.jobWithFeedbackStats?.total ?? 0
            : jobCounts === undefined
            ? undefined
            : APIJobsPerStatusModel.total(jobCounts) +
              instanceFetch.value.batchProcessCount
        : undefined
}
